import { Clear, Search } from '@mui/icons-material';
import { Avatar, CardHeader, Divider, IconButton, InputBase } from '@mui/material';
import React, { FunctionComponent, useState } from 'react';

type SimpleSearchProps = {
  setSearch: (searchValue: string) => void;
  placeholder: string;
};

const SimpleSearch: FunctionComponent<SimpleSearchProps> = (props: SimpleSearchProps) => {
  const [searchValue, setSearchValue] = useState('');

  const updateValue = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const newValue = event.target.value.toLowerCase();
    setSearchValue(newValue);
    props.setSearch(newValue);
  };

  const handleKeySubmit = (event?: React.KeyboardEvent) => {
    if (event && event.key && event.key !== 'Enter') {
      return;
    }
    props.setSearch(searchValue);
  };

  const handleClickSubmit = () => props.setSearch(searchValue);

  const clearState = () => {
    setSearchValue('');
    props.setSearch('');
  };

  return (
    <>
      <CardHeader
        title={
          <InputBase
            id={'search-field'}
            onKeyPress={handleKeySubmit}
            onChange={updateValue}
            placeholder={props.placeholder}
            value={searchValue}
            fullWidth
          />
        }
        avatar={
          <Avatar style={{ marginTop: -8, backgroundColor: '#269AE0' }}>
            <Search />
          </Avatar>
        }
        action={
          searchValue ? (
            <IconButton onClick={clearState} size="large">
              <Clear />
            </IconButton>
          ) : (
            <IconButton onClick={handleClickSubmit} size="large">
              <Search />
            </IconButton>
          )
        }
        style={{ padding: 8 }}
      />
      <Divider />
    </>
  );
};

export default SimpleSearch;
